/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';

import useResponsive from '@hooks/useResponsive';
import { setAuthenticated } from '@store/reducers/authReducer';
import authServices from '@services/auth';
import Content from './Content';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

const drawerWidth = 270;
const headerHeight = 80;

// [IMPORVE] reponsive and props
function MainLayout() {
  const [open, setOpen] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSm = useResponsive('down', 600);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    await authServices.logout();
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    dispatch(setAuthenticated(false));
    navigate('/admin');
  };

  useEffect(() => {
    setOpen(!isSm);
  }, [isSm]);

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar
        handleLogout={handleLogout}
        handleDrawerClose={handleDrawerClose}
        open={open}
        drawerWidth={drawerWidth}
        headerHeight={headerHeight}
      />
      <Box
        sx={(theme) => ({
          flexGrow: 1,
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
          }),
          marginLeft: `-${drawerWidth}px`,
          ...(open && {
            transition: theme.transitions.create('margin', {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen
            }),
            marginLeft: 0
          }),
          overflowX: 'hidden'
        })}
      >
        <Header
          handleDrawerOpen={handleDrawerOpen}
          open={open}
          isSm={isSm}
          drawerWidth={drawerWidth}
        />
        <Content
          headerHeight={headerHeight}
          drawerWidth={drawerWidth}
          open={open}
        />
        <Footer open={open} drawerWidth={drawerWidth} />
      </Box>
    </Box>
  );
}

export default MainLayout;
